import { render, staticRenderFns } from "./TestCaseItem.vue?vue&type=template&id=1df57b7c&scoped=true&"
import script from "./TestCaseItem.vue?vue&type=script&lang=js&"
export * from "./TestCaseItem.vue?vue&type=script&lang=js&"
import style0 from "./TestCaseItem.vue?vue&type=style&index=0&id=1df57b7c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1df57b7c",
  null
  
)

export default component.exports